import React, { useState } from 'react';
import { Select, MenuItem, FormControl } from '@mui/material';
import ActiveConfirmDialog from './ActiveConfirmDialog';

const ToggleSelect = ({ initialStatus, onUpdateStatus }) => {
  const [status, setStatus] = useState(initialStatus);
  const [tempStatus, setTempStatus] = useState(initialStatus);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    let message = "";
    if (newStatus === 0) {
      message = "Are you sure you want to set the status to 'Inactive'?";
    } else if (newStatus === 2) {
      message = "Are you sure you want to set the status to 'Block'?";
    } else {
      message = "Are you sure you want to set the status to 'Active'?";
    }
    setDialogMessage(message);
    setTempStatus(newStatus);
    setDialogOpen(true);
  };

  const handleConfirm = () => {
    setStatus(tempStatus);
    onUpdateStatus(tempStatus);
    setDialogOpen(false);
  };

  const handleClose = () => {
    setTempStatus(status);
    setDialogOpen(false);
  };

  return (
    <div style={{ margin: '10px 0' }}>
      <FormControl
        variant="outlined"
        fullWidth
        sx={{
          maxHeight: '40px', // Set a maximum height
          margin: '0 5px', // Adjust margin as needed
          borderRadius: '5px',
        }}
      >
        <Select
          labelId="status-select-label"
          value={status}
          onChange={handleStatusChange}
          sx={{
            height: '34px', // Set height to match FormControl
            display: 'flex',
            alignItems: 'center',
            backgroundColor: status === 1 ? '#4CAF50' : status === 0 ? '#FFA500' : '#FF0000',
            color: 'white',
            '& .MuiSelect-icon': {
              color: 'white', // Adjust icon color if needed
            }
          }}
        >
          <MenuItem value={1}>Active</MenuItem>
          <MenuItem value={0}>Inactive</MenuItem>
          <MenuItem value={2}>Block</MenuItem>
        </Select>
      </FormControl>
      <ActiveConfirmDialog
        open={dialogOpen}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
        message={dialogMessage}
      />
    </div>
  );
};

export default ToggleSelect;
